import { render, staticRenderFns } from "./memberAdd.vue?vue&type=template&id=381dcdf4&scoped=true&"
import script from "./memberAdd.vue?vue&type=script&lang=js&"
export * from "./memberAdd.vue?vue&type=script&lang=js&"
import style0 from "./memberAdd.vue?vue&type=style&index=0&id=381dcdf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381dcdf4",
  null
  
)

export default component.exports